import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgRemove = function SvgRemove(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#remove_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M3.526 3.526a2.976 2.976 0 000 4.209L7.791 12l-4.265 4.265a2.976 2.976 0 104.209 4.21L12 16.208l4.265 4.265a2.976 2.976 0 004.21-4.209L16.209 12l4.265-4.265a2.976 2.976 0 00-4.209-4.21L12 7.792 7.735 3.526a2.976 2.976 0 00-4.209 0z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "remove_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgRemove;